// https://developer.sgmarkets.com/docs/design-system/v5/foundations/colour.html

// ████████╗██╗   ██╗██████╗ ███████╗███████╗
// ╚══██╔══╝╚██╗ ██╔╝██╔══██╗██╔════╝██╔════╝
//    ██║    ╚████╔╝ ██████╔╝█████╗  ███████╗
//    ██║     ╚██╔╝  ██╔═══╝ ██╔══╝  ╚════██║
//    ██║      ██║   ██║     ███████╗███████║
//    ╚═╝      ╚═╝   ╚═╝     ╚══════╝╚══════╝

export const INTERFACE_COLORS = [
  'primary',
  'primary-alt',
  'secondary',
  'light',
  'dark',
  'info',
] as const;
export type InterfaceColor = (typeof INTERFACE_COLORS)[number];

export const CONTEXTUAL_COLORS = ['info', 'success', 'warning', 'danger'] as const;
export type ContextualColor = (typeof CONTEXTUAL_COLORS)[number];

export const BRAND_COLORS = ['socgen', 'black', 'white'] as const;
export type BrandColor = (typeof BRAND_COLORS)[number];

export const SECONDARY_COLORS = [
  'valencia',
  'apricot',
  'puerto-rico',
  'cornflower-blue',
  'spicy-mix',
  'faded-jade',
  'royal-blue',
  'heather',
  'victoria',
  'azure',
  'mako',
  'mars',
  'mercury',
  'manatee',
  'dodger-blue',
  'turquoise-blue',
  'pacific-blue',
  'buttercup',
  'copper-rust',
  'east-bay',
  'plantation',
] as const;
export type SecondaryColor = (typeof SECONDARY_COLORS)[number];

export const COLORS = [
  ...CONTEXTUAL_COLORS,
  ...BRAND_COLORS,
  ...SECONDARY_COLORS,
  ...INTERFACE_COLORS,
] as const;
export type Color = (typeof COLORS)[number];

// ██╗   ██╗████████╗██╗██╗     ██╗████████╗██╗███████╗███████╗
// ██║   ██║╚══██╔══╝██║██║     ██║╚══██╔══╝██║██╔════╝██╔════╝
// ██║   ██║   ██║   ██║██║     ██║   ██║   ██║█████╗  ███████╗
// ██║   ██║   ██║   ██║██║     ██║   ██║   ██║██╔══╝  ╚════██║
// ╚██████╔╝   ██║   ██║███████╗██║   ██║   ██║███████╗███████║
//  ╚═════╝    ╚═╝   ╚═╝╚══════╝╚═╝   ╚═╝   ╚═╝╚══════╝╚══════╝
